module.exports = __webpack_public_path__ + "static/media/checkverde.0e31abd8.svg";